import React from "react"
import { AlgoliaCheckboxCategory } from "../../../controller/state/types"
import TagFilterOptions from "../../../filters/TagFilterOptions"

interface Props {
  category: AlgoliaCheckboxCategory
}

const FiltersModalTagFilter = ({ category }: Props) => {
  return (
    <div className="px-3">
      <TagFilterOptions category={category} />
    </div>
  )
}

export default FiltersModalTagFilter
